import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { ClsArmData } from './ClsArmData';

@Injectable({
  providedIn: 'root'
})
export class ClsArmService {
  private clsarmdata: ClsArmData = null;
  private updateKey: number = 0;
  constructor() { }

  getSelf(): ClsArmData {
    return this.clsarmdata;
  }

  fillData(msgObj: any) {
    if (this.clsarmdata) {
      if (msgObj.CLS && msgObj.ARM)
        this.clsarmdata.fillData(msgObj.CLS, msgObj.ARM);
    }
    else
      this.clsarmdata = new ClsArmData(msgObj.CLS, msgObj.ARM);

    this.updateKey++;
  }
}
